import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ComandosUsuarioComponent } from './comandos.usuario.component';
import { ListadoComponent } from '../../helpers/components/generalList/generallist.component';
import { SharedModule } from '../../helpers/shared.module';
import { VistaComandoComponent } from './vista.comando.component';
import { TranslatorModule } from 'angular-translator';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

const componentes = [
  ComandosUsuarioComponent,
  VistaComandoComponent,
];

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    SharedModule,
    TranslatorModule,
    NgbModule,
  ],
  exports: componentes,
  declarations: componentes,
  providers: [],
})
export class UsuariosModule { }



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usuarios/usuarios.module.ts